import axios from '@/helpers/axios';
import dataStore from '@/helpers/data';
import helperError from '@/helpers/error';
import language from '@/helpers/language';

const state = {
  configs: [], // [{ id, name, description }]
  loaded: false,
};

const getters = {
  match: (state) => state,
};

const actions = {
  reset({ commit }) {
    commit('SET_CONFIGS', []);
    commit('SET_LOADED', false);
  },

  // Fetch the selectable match configs from api-core via the PHP /v1/matchconfigs proxy.
  async configs({ commit }) {
    this.dispatch('app/loading', true);
    return await axios.get('/matchconfigs').then(
      (response) => {
        this.dispatch('app/loading', false);
        if (response.data.response !== undefined && Array.isArray(response.data.response)) {
          commit('SET_CONFIGS', response.data.response);
          commit('SET_LOADED', true);
        }
      },
      (error) => {
        this.dispatch('app/loading', false);
        helperError(this, error, language(dataStore.language.current)['errorOccured']);
      }
    );
  },

  // Persist the chosen match config id via the existing gather/update PATCH flow.
  selectConfig({ commit }, id) {
    const data = dataStore.getter(this.getters);
    const item = { key: 'match_config', value: { name: 'Match config', type: 'select', value: id } };
    this.dispatch('gather/update', { token: data.gather.info.token, item: item });
    commit('SET_SELECTED', id);
  },

  // Persist the chosen starter (knife|zeus|off) via the existing gather/update PATCH flow.
  selectStarter({ commit }, starter) {
    const data = dataStore.getter(this.getters);
    const item = { key: 'starter', value: { name: 'Starter round', type: 'select', value: starter } };
    this.dispatch('gather/update', { token: data.gather.info.token, item: item });
    commit('SET_STARTER', starter);
  },

  // Persist the chosen overtime mode (none|once|unlimited) via the existing gather/update PATCH flow.
  selectOvertime({ commit }, overtime) {
    const data = dataStore.getter(this.getters);
    const item = { key: 'overtime', value: { name: 'Overtime', type: 'select', value: overtime } };
    this.dispatch('gather/update', { token: data.gather.info.token, item: item });
    commit('SET_OVERTIME', overtime);
  },

  // Persist the friendly fire mode (normal|faceit) via the gather/update PATCH flow.
  selectFriendlyFire(_ctx, mode) {
    const data = dataStore.getter(this.getters);
    const item = { key: 'friendly_fire', value: { name: 'Friendly fire', type: 'select', value: mode, options: ['normal', 'faceit'] } };
    this.dispatch('gather/update', { token: data.gather.info.token, item: item });
  },

  // Persist the allowed warmup utility (comma list of he,flash,smoke,molotov,decoy; '' = none).
  selectWarmupUtil(_ctx, kinds) {
    const data = dataStore.getter(this.getters);
    const item = {
      key: 'warmup_util',
      value: { name: 'Warmup utility', type: 'multiselect', value: kinds, options: ['he', 'flash', 'smoke', 'molotov', 'decoy'] },
    };
    this.dispatch('gather/update', { token: data.gather.info.token, item: item });
  },
};

const mutations = {
  SET_CONFIGS(state, payload) {
    state.configs = payload;
  },
  SET_LOADED(state, payload) {
    state.loaded = payload;
  },
  // SET_SELECTED / SET_STARTER are intentionally no-ops on state:
  // the source of truth for current values is gather.config (the EAV rows),
  // read in the component. These commits exist only to keep the action shape
  // symmetric with map.js and to leave a hook for future local caching.
  SET_SELECTED() {},
  SET_STARTER() {},
  SET_OVERTIME() {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
